import React from "react";
import { Archive, CheckCircle2, MoreHorizontal, RotateCcw, Trash2 } from "lucide-react";

// Wave 3 — action hierarchy: Approve & Forward / Return to Sender / Archive as
// the primary tier, destructive Delete demoted behind "More actions".
const PrimaryActions = ({ processing = false, onApprove, onReview, onArchive, onDelete }) => (
  <div className="file-card__actions" style={{ marginTop: "1rem" }}>
    <div className="file-card__actions-primary">
      <button
        type="button"
        onClick={onApprove}
        className="file-card__btn file-card__btn-approve"
        disabled={processing}
      >
        <CheckCircle2 size={17} aria-hidden="true" /> Approve &amp; Forward
      </button>

      <button
        type="button"
        onClick={onReview}
        className="file-card__btn file-card__btn-review"
        disabled={processing}
      >
        <RotateCcw size={17} aria-hidden="true" /> Return to Sender
      </button>

      <button
        type="button"
        onClick={onArchive}
        className="file-card__btn file-card__btn-archive"
        disabled={processing}
      >
        <Archive size={17} aria-hidden="true" /> Archive
      </button>
    </div>

    <details className="file-card__more-actions">
      <summary>
        <MoreHorizontal size={18} aria-hidden="true" /> More actions
      </summary>
      <div className="file-card__more-menu">
        <button
          type="button"
          onClick={onDelete}
          className="file-card__danger-action"
          disabled={processing}
        >
          <Trash2 size={16} aria-hidden="true" /> Delete document
        </button>
      </div>
    </details>
  </div>
);

export default PrimaryActions;
